import { render, staticRenderFns } from "./Workspaces.vue?vue&type=template&id=421ccf63&scoped=true&"
import script from "./Workspaces.vue?vue&type=script&lang=js&"
export * from "./Workspaces.vue?vue&type=script&lang=js&"
import style1 from "./Workspaces.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421ccf63",
  null
  
)

export default component.exports